import styles from './VerticalDivider.module.scss';
const VerticalDivider = () => {
  return <div className={styles.divider} />;
};

export { VerticalDivider };
